import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import SubCategoriasCreate from "./SubCategoriasCreate";
import axios from "axios";
import {
  ButtonGroup,
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import Footer from "../../../layout/Footer/Footer";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";

function ListadoSubCategorias() {
  const { user } = useContext(AuthContext);
  const URL_SUB_CATEGORIAS = process.env.REACT_APP_URL_SUB_CATEGORIAS;
  const URL_CATEGORIAS = process.env.REACT_APP_URL_CATEGORIAS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;

  const [subCategorias, setSubCategorias] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [selectedCategoria, setSelectedCategoria] = useState("");
  const [modal, setModal] = useState(false);
  const [name, setName] = useState("");
  const toggle = () => setModal(!modal);
  const [text, setText] = useState(false);

  const [idEdit, setIdEdit] = useState()

  useEffect(() => {
    axios
      .get(URL_SUB_CATEGORIAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allSubCategorias = response.data;
        setSubCategorias(allSubCategorias);
      })
      .catch((err) => {
        console.log(err);
      });

        axios
      .get(URL_CATEGORIAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allCategorias = response.data;
        setCategorias(allCategorias);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function editConcepto(event) {
    event.preventDefault();
    const URL_SUB_CATEGORIAS_EDIT = `${process.env.REACT_APP_URL_SUB_CATEGORIAS}/${idEdit}`;
    axios
      .patch(
        URL_SUB_CATEGORIAS_EDIT,
        {
          name,
          categorias: selectedCategoria
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios
        .post(
          URL_LOGS,
          {
            tipo:'Editar SubCategorias',
            detalle: name,
            user: user.id
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        toggle();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        window.location.reload();
      })
       .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function jalaInfo(idEdit, name, categoria) {
        setName(name);
        setIdEdit(idEdit);
        setSelectedCategoria(categoria)
        toggle();
  }

  return (
    <>
      <Header />
      <br />
      <br />
      <div className="container">
        { user.menu_gastos ? (
          <div className="row">
            {
              <div className="col-md-6 col-sm-6">
                <div className="card">
                  <div className="card-body">
                    <h3 align="center">SubCategorias</h3>
                    <Table
                      size="sm"
                      striped
                      borderless
                      className="table-responsive-xl"
                    >
                      <thead>
                        <tr>
                          <th className="tituloTabla">Nombre</th>
                          <th className="tituloTabla">Categoria</th>
                          <th className="tituloTabla">Editar</th>
                        </tr>
                      </thead>
                      <tbody>
                        {subCategorias
                          .sort((a, b) => (a.name > b.name ? 1 : -1))
                          .map((a) => {
                              return (
                                <tr>
                                  <td>{a.name}</td>
                                  <td>{a.categorias[0].name}</td>
                                  <td>
                                    <Button
                                      color="info"
                                      id="Editar"
                                      size="sm"
                                      onClick={(e) => jalaInfo(a._id, a.name, a.categorias[0]._id)}
                                    >
                                      <i class="far fa-edit"></i>{" "}
                                    </Button>
                                  </td>
                                </tr>
                              );
                          })}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            }
            <div className="col-md-6 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <SubCategoriasCreate />
                </div>
              </div>
            </div>
          </div>
        ) : undefined}
      </div>
      <Modal size="sm" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Editar SubCategorias</ModalHeader>
        <ModalBody>
          <Label className="mr-sm-2">Nombre</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={name}
            required
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
            <Label className="mr-sm-2">Categoria</Label>
                <Input
                  // bsSize="sm"
                  type="select"
                  required
                  value={selectedCategoria}
                  onChange={(e) => setSelectedCategoria(e.target.value)}
                >
                  <option value="0">Selecciona</option>
                  {categorias
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                        return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editConcepto}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoSubCategorias;
